import { type ReactElement, useEffect, useState } from "react";
import { UseFormRegister } from "react-hook-form";
import cx from "classnames";

import Text, { TextWeight } from "../../atoms/Text";
import * as s from "./styles";

export interface Props {
  name: string;
  value: string;
  register?: UseFormRegister<any>;
  text?: string;
  textWeight?: TextWeight;
  isChecked?: boolean;
  isDisabled?: boolean;
}

export default function Radio({
  name,
  register,
  text,
  textWeight = "regular",
  value,
  isChecked = false,
  isDisabled = false,
}: Props): ReactElement {
  const [checked, setChecked] = useState<boolean>(isChecked);
  const [disabled, setDisabled] = useState<boolean>(isDisabled);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  useEffect(() => {
    setDisabled(isDisabled);
  }, [isDisabled]);

  const hasLabelText = Boolean(text);
  const isControlledByReactHookForm = Boolean(register);

  const inputProps =
    isControlledByReactHookForm && register
      ? { ...register(name, { required: true }) }
      : {
          checked,
          disabled,
          onChange: () => setChecked(!checked),
          name,
        };

  if (!hasLabelText) {
    return <input type="radio" id={value} value={value} {...inputProps} />;
  }

  return (
    <label className={s.getCardStyle(checked, isDisabled)} htmlFor={value}>
      <input
        type="radio"
        className="sr-only"
        id={value}
        value={value}
        {...inputProps}
      />
      <div className="flex items-center w-full">
        <div className="flex-shrink-0 mr-3">
          <div
            className={cx(s.radioIndicator, {
              "border-white": !checked,
              "border-green-300": checked,
            })}
          >
            {checked && <div className="w-4 h-4 rounded-full bg-green-300" />}
          </div>
        </div>

        <Text color="white" weight={textWeight}>
          {text}
        </Text>
      </div>
    </label>
  );
}
